if (!customElements.get('wls-faq')) {
    class WLSFAQ extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                stickyOffset: 100,
                stickyClass: 'is-sticky',
                activeClass: 'active',
                anchor: 'js-wls-faq-anchor',
                anchorsWrapper: 'js-wls-anchors-wrapper',
                faqContentWrapper: 'js-wls-faq-content',
                isMobile: window.innerWidth <= 1024,
            };
            this.elements = {
                anchors: this.querySelectorAll(`.${this.classes.anchor}`),
                anchorsWrapper: this.querySelector(`.${this.classes.anchorsWrapper}`),
                faqContentWrapper: this.querySelector(`.${this.classes.faqContentWrapper}`),

            }
            // this.toggle = this.toggle.bind(this);
        }

        connectedCallback() {
            this.handleAnchorClick();
            this.moveAnchorsOnScroll();
            this.observeSectionsOnScroll();
        }

        handleAnchorClick() {
            if (this.elements.anchors.length > 0) {
                this.elements.anchors.forEach(anchor => {
                    anchor.addEventListener('click', () => {
                        this.removeActiveClass(this.elements.anchors)
                        anchor.classList.add('active');
                    })
                })
            }
        }

        removeActiveClass(elements) {
            elements.forEach(el => {
                el.classList.remove(this.classes.activeClass)
            })
        }

        moveAnchorsOnScroll() {
            if (this.classes.isMobile && this.elements.anchorsWrapper) {
                window.addEventListener('scroll', () => {
                    if (window.scrollY > 50) {
                        this.elements.anchorsWrapper.classList.add(this.classes.stickyClass);
                    } else {
                        this.elements.anchorsWrapper.classList.remove(this.classes.stickyClass);
                    }
                });
            }
        }

        observeSectionsOnScroll() {
            const sections = [];

            this.elements.anchors.forEach(anchor => {
                const href = anchor.getAttribute('href');
                if (href && href.startsWith('#')) {
                    const section = document.querySelector(href);
                    if (section) {
                        sections.push({ anchor, section });
                    }
                }
            });

            window.addEventListener('scroll', () => {
                let current = null;

                sections.forEach(({ anchor, section }) => {
                    const rect = section.getBoundingClientRect();
                    if (rect.top <= 150 && rect.bottom > 150) {
                        current = anchor;
                    }
                });

                if (current) {
                    this.removeActiveClass(this.elements.anchors);
                    current.classList.add(this.classes.activeClass);
                }
            });
        }


    }

    customElements.define('wls-faq', WLSFAQ);
}